module.exports = __webpack_public_path__ + "img/hero.3bd883bf.svg";